// extracted by mini-css-extract-plugin
export default {"msg_container":"V9","message":"W9","show":"X9","fromRD":"Y9","fromCustomer":"Z9","note":"aaa","loading":"baa","image":"caa","initials":"eaa","input_wrapper":"faa","input":"gaa"};
    if(module.hot) {
      // 1713211528410
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  